/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Modal from "react-modal";
import { Link, useNavigate } from "react-router-dom";
import { GiStarShuriken } from "react-icons/gi";
import { FaMoon } from "react-icons/fa";
import { BiSearch } from "react-icons/bi";
import { BsFillSunFill } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";
import useAuth from "../../Hooks/useAuth";
import { headerLinks } from "../../data/Data";
import { useEffect } from "react";
import { HashLink } from "react-router-hash-link";
Modal.setAppElement("#root");
const Header = () => {
  const {showDummyImage} = useAuth()
  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [shuffle, setShuffle] = useState(true);
  const [theme, setTheme] = useState(false);
  const [selected, setSelected] = useState("");
  const [headertop, setHeadertop] = useState(true);
  const { setSideBar, user,stickyNav,setStickyNav } = useAuth();

  
  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  
  useEffect(()=>{
    window.addEventListener("scroll", () => {
      if (window.scrollY > 200) {
        setStickyNav(true);
      } else {
        setStickyNav(false);
      }
    });
  },[setStickyNav])

  return (
    <header id="header">
      {headertop ? (
        <div className="header-top">
          <p>Rarible fees reduced to 1% for buyer, 1% for seller ✨</p>
          <button className="remove" onClick={()=>setHeadertop(false)}>
            <FaTimes />
          </button>
        </div>
      ):""}

      <div className={`header-bottom ${stickyNav ? 'sticky':''}`}>
        <div className="container">
          <div className="header-wrapper">
            <div className="header-bottom-left">
              <Link to="/" className="logo">
                <div className="logo-icon">
                  <GiStarShuriken />
                </div>
                <span>NFTs</span>
              </Link>
              <div className="header-searchBar">
                <button onClick={openModal}>
                  <BiSearch />
                </button>
                <Modal
                  className="modal"
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  overlayClassName="Overlay"
                >
                  <div className="modal-search">
                      <form className="modal-search-bar">
                        <input
                          className="modal-search-bar-input"
                          type="text"
                          placeholder="Search by collection, NFT or user"
                        />
                        <button className="searchBar-modal-btn">
                          <BiSearch />
                        </button>
                      </form>
                  </div>
                </Modal>
              </div>
            </div>
            <nav className="nav">
              <ul className="navbar">
                {headerLinks?.map((link, i) => (
                  <li key={i}>
                    <button
                      onClick={() => {
                        setSelected(link?.headerName);
                        navigate(`/${link?.route}`);
                      }}
                      className={`navbar-link ${
                        selected === link.headerName ? "nav-active" : ""
                      }`}
                    >
                      {link?.headerName}
                    </button>
                    {link?.dropdown?.length && (
                      <ul className="sub-menu">
                        {link?.dropdown?.map((subLink, j) => (
                          <li key={j} className="sub-menu-item">
                            <HashLink
                              to={`/${subLink?.route}/#header`}
                              className="sub-menu-link"
                            >
                              {subLink?.pageName}
                            </HashLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
            <div className="header-bottom-right">
              {user?.email ? (
                <Link to={`/profile/${1}`}>
                  <div className="user">
                    <img src={require("../../assets/images/home/profile_pic.png")} alt={'profilePic'} onError={({currentTarget},imageSize='50X50')=>showDummyImage({currentTarget},imageSize)}/>
                  </div>
                </Link>
              ) : (
                <Link to={"/signin"} className="signIn-link">
                  Sign In
                </Link>
              )}
              {shuffle ? (
                <Link to="/uploadwork">
                  <button className="Connect-wallet">Submit Work</button>
                </Link>
              ) : (
                <Link to="/connectwallet">
                  <button className="Connect-wallet">Connect Wallet</button>
                </Link>
              )}
              <button
                className="theme-mode"
                onClick={() => {
                  setTheme(!theme);
                }}
              >
                {theme ? (
                  <FaMoon className="dark" />
                ) : (
                  <BsFillSunFill className="theme" />
                )}
              </button>
            </div>
            <div
              className="menuBar"
              onClick={() => {
                setSideBar(true);
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
